import {
  CarOutlined,
  CloseCircleOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import {
  Button,
  Carousel,
  Col,
  Divider,
  Input,
  Modal,
  notification,
  Row,
  Select,
} from "antd";
import "antd/dist/antd.css";
import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { Preloader, ThreeDots } from "react-preloader-icon";
import { useLocation } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import NavigationBar from "../../components/NavigationBar/NavigationBar";
import {
  apiGetBanner,
  apiGetBranch,
  apiGetMachineList,
  apiGetMyCoupon,
  apiGetNameUser,
  apiGetStatusMachine,
  apiRemoteStartMachine,
} from "../../services/apis/site";
import {
  getTextMode,
  getTextOption,
  numberWithCommas,
} from "../../untills/function";
import "./Home.css";

let timeout2;
let timeStatus;

const { Search } = Input;
const { Option } = Select;

const Home = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const code = params.get("code");
  const type = params.get("type");
  const [bxStatus, setBxStatus] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [branchList, setBranchList] = useState(undefined);
  const [bannertList, setBannerList] = useState([]);
  const [lat, setLat] = useState("");
  const [lng, setLng] = useState("");
  const [loadingBranch, setLoadingBranch] = useState(true);
  const [machineList, setMachineList] = useState(undefined);
  const [siteSelect, setSiteSelect] = useState(undefined);
  const [siteSelectLocation, setSiteSelectLocation] = useState(undefined);
  const userInfo = JSON.parse(localStorage.getItem("rondori_user"));
  const [isModalTask, setIsModalTask] = useState(false);
  const [statusMachine, setStatusMachine] = useState(undefined);
  const [isLoadData, setIsLoadData] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [myCoupon, setMyCoupon] = useState(undefined);
  const [total, setTotal] = useState(0);
  const [couponSelected, setCouponSelected] = useState("");

  const getMyCoupon = async () => {
    let coupon = await apiGetMyCoupon();
    if (coupon && coupon.status) setMyCoupon(coupon);
    else setMyCoupon(undefined);
  };

  useEffect(() => {
    if (code) {
      getName(code, type);
      if (isMobile) {
        console.log("isMobile");
        window.location.replace("rondori://");
      }
    }
  }, [code, type]);

  useEffect(() => {
    let mounted = true;
    const onEvent = (event) => {
      if (mounted) {
        setLat(event.coords.latitude);
        setLng(event.coords.longitude);
      }
    };

    navigator.geolocation.getCurrentPosition(onEvent);
    let watchId = navigator.geolocation.watchPosition(onEvent);

    const timeout = setInterval(() => {
      const getDataList = async () => {
        const branch = await apiGetBranch(keyword, lat, lng);
        if (branch && branch.status) {
          setBranchList(branch.result || []);
          setLoadingBranch(false);
        }
      };

      getDataList();
    }, 1000);

    return () => {
      clearInterval(timeout);
      mounted = false;
      navigator.geolocation.clearWatch(watchId);
    };
  }, [keyword, lat, lng]);

  useEffect(() => {
    getBannerList();
  }, []);

  const showList = (siteId) => {
    setBxStatus(true);

    timeout2 = setInterval(() => {
      getMachine(siteId);
    }, 1000);
  };

  const getName = async (codeuser, type_login) => {
    let name = await apiGetNameUser(codeuser, type_login);
    if (name.status) {
      localStorage.setItem("rondori_token", name.token);
      localStorage.setItem("rondori_user", JSON.stringify(name.result));
    }
  };

  const getMachine = async (siteId) => {
    const machinelist = await apiGetMachineList(siteId);

    if (machinelist && machinelist.status) {
      setMachineList(machinelist.result);
      setSiteSelect(machinelist.site_name);
    }
  };

  const getBannerList = async () => {
    const banner = await apiGetBanner();
    if (banner && banner.status) setBannerList(banner.result || []);
  };

  const onSearch = (value) => {
    setLoadingBranch(true);
    setKeyword(value);
  };

  const hideShowList = (e) => {
    e.preventDefault();
    setBxStatus(false);
    setMachineList(undefined);
    setSiteSelect(undefined);
    clearInterval(timeout2);
  };

  const showModal = (machine_id) => {
    setIsLoadData(true);
    setIsModalTask(true);
    getMyCoupon();

    timeStatus = setInterval(async () => {
      let statusMachine = await apiGetStatusMachine(machine_id);
      if (statusMachine && statusMachine.status) {
        setIsLoadData(false);
        setStatusMachine(statusMachine.result);
      } else {
        setIsLoadData(false);
        handleCancel();
        openNotification("topRight", "กรุณาลองใหม่อีกครั้ง");
      }
    }, 1000);
  };

  const openNotification = (placement, text) => {
    notification.warning({
      message: `Notification`,
      description: text,
      placement,
    });
  };

  const handleCancel = () => {
    setIsModalTask(false);
    setStatusMachine(undefined);
    clearInterval(timeStatus);
    setCouponSelected("");
  };

  const renderIcon = (type) => {
    switch (type) {
      case 1:
        return "/assets/machine/e-wash.png";
      case 2:
        return "/assets/machine/e-dry.png";
      default:
        return "/assets/machine/e-wash.png";
    }
  };

  const DropdownCoupon = (value) => {
    setCouponSelected(value);
    const result = myCoupon.result.find(({ coupon_id }) => coupon_id === value);
    const newTotal = result
      ? statusMachine.remain_balance - result.discount
      : statusMachine.remain_balance;
    setTotal(newTotal);
  };

  const remoteStart = async (machine_id) => {
    const data = {
      machine_id: machine_id,
      coupon_id: couponSelected ? couponSelected : 0,
    };
    const start = await apiRemoteStartMachine(data);
    if (start && start.status) {
      setIsLoading(false);
      notification.success({
        message: start.message,
        description: `กรุณากดปุ่ม Start หน้าเครื่อง`,
        placement: "topRight",
      });

      handleCancel();
    } else {
      setIsLoading(false);
      notification.error({
        message: `Notification`,
        description: start.message,
        placement: "topRight",
      });
    }
  };

  return (
    <div className="App">
      <Navbar />
      <div className="bx-sh-banner">
        <div className="cov-banner">
          <img
            alt=""
            className="logo-rondori"
            src="/assets/rondori/rondori.png"
          />
          <img alt="" className="mascot" src="/assets/rondori/mascot.png" />
          <div className="des-rondori">
            <p className="title-rondori">Hello {userInfo && userInfo.name}.</p>
            <p className="title-rondori">
              Code {localStorage.getItem("rondori_id")}
            </p>
          </div>
        </div>
      </div>

      <div className="bx-action">
        <p className="title-sec">Promotion</p>
        <p className="des-section">
          Here you can keep up with the latest specials.
        </p>
        <div className="slide-promotion">
          <Carousel autoplay autoplaySpeed={5000} dots={false}>
            {bannertList.length &&
              bannertList.map((item) => (
                <div className="bx-banner" key={item.id}>
                  <img
                    alt="bannerimage"
                    className="img-banner"
                    src={"https://prism.imsoftware.dev" + item.image}
                  />
                </div>
              ))}
          </Carousel>
        </div>

        <div className="section-location">
          <div className="top-section">
            <p className="title-sec col-top">Location</p>
            <div className="cov-search">
              <Search
                placeholder="Search"
                onSearch={onSearch}
                className="input-search"
              />
            </div>
          </div>
          <div className="list-branch">
            <Row gutter={[16, 16]}>
              {loadingBranch ? (
                <div className="loading">
                  <Preloader
                    use={ThreeDots}
                    size={60}
                    strokeWidth={6}
                    strokeColor="#c55a59"
                    duration={1500}
                  />
                </div>
              ) : null}
              {branchList &&
                (branchList.length < 0 || []) &&
                branchList.map((item) => (
                  <Col
                    xs={{ span: 12 }}
                    sm={{ span: 12 }}
                    md={{ span: 8 }}
                    lg={{ span: 8 }}
                    key={item.id}
                  >
                    <div
                      className="bx-branch"
                      onClick={(e) => {
                        e.preventDefault();
                        showList(item.id);
                        setSiteSelectLocation({ ...item.location });
                      }}
                    >
                      <div className="bx-img-branch">
                        <img
                          className="img-branch"
                          alt="img-branch"
                          src={"https://rondori.com" + item.image}
                        />
                      </div>
                      <p className="branch-name">{item.name_th}</p>
                      <div className="bx-ico">
                        <Row gutter={[16, 16]}>
                          <Col span={12}>
                            <div className="data-type">
                              <div className="img-type">
                                <img
                                  alt=""
                                  className="type"
                                  src="/assets/icon/wash.png"
                                />
                                <p className="name-type">wash</p>
                              </div>
                              <div className="bx-ava">
                                <p className="empty-machine">ว่าง</p>
                                <p className="empty-machine">
                                  {item.washer_available} / {item.total_washer}
                                </p>
                              </div>
                            </div>
                          </Col>
                          <Col span={12}>
                            <div className="data-type">
                              <div className="img-type">
                                <img
                                  alt=""
                                  className="type"
                                  src="/assets/icon/dry.png"
                                />
                                <p className="name-type">dry</p>
                              </div>
                              <div className="bx-ava">
                                <p className="empty-machine">ว่าง</p>
                                <p className="empty-machine">
                                  {item.dryer_available} / {item.total_dryer}
                                </p>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                ))}
            </Row>
          </div>
        </div>
      </div>

      {bxStatus && (
        <div className="cov-bx">
          <div className="bx-status">
            <div className="sec-close">
              <Button className="btn-close" onClick={(e) => hideShowList(e)}>
                <CloseCircleOutlined className="icon-close" />
              </Button>
            </div>
            {machineList ? (
              <>
                <div className="name-b-s">
                  {siteSelect && siteSelect.name_th}
                </div>
                <div className="location-container">
                  <div className="des-b-s">
                    ตรวจสอบเครื่องที่ว่างเพื่อเข้ารับการใช้งานได้
                  </div>
                  <a
                    href={`https://maps.google.com?q=${siteSelectLocation.latitude},${siteSelectLocation.longitude}`}
                    target="_blank"
                    rel="noreferrer"
                    className="location-icon"
                  >
                    <CarOutlined />
                  </a>
                </div>
                <div
                  className="list-m"
                  onClick={() => {
                    if (!localStorage.getItem("rondori_token")) {
                      notification.error({
                        message: `Notification`,
                        description: `โปรดลงชื่อเข้าใช้ก่อนค่ะ`,
                        placement: "topRight",
                      });
                    }
                  }}
                >
                  {machineList &&
                    machineList.map((item, index) => (
                      <div key={index} className="o-m-b">
                        <Row gutter={[16, 16]}>
                          <Col span={6}>
                            <img
                              alt=""
                              className="img-status-m"
                              src={renderIcon(item.machine_type_id)}
                            />
                          </Col>
                          <Col span={12}>
                            <p className="t-n-m">{item.machine_name.name_th}</p>
                            <p className="s-m">
                              ขนาด {item.machin_size} , {item.price} บาท
                            </p>
                            <div className="b-status">
                              <div className="cov-dot-status">
                                <div
                                  className={`dot-s ${
                                    item.machine_status.name_th ===
                                    "พร้อมใช้งาน"
                                      ? "dot-g"
                                      : "dot-r"
                                  }`}
                                ></div>
                              </div>
                              <p className="t-status">
                                {item.machine_status.name_th}
                              </p>
                            </div>
                          </Col>
                          <Col span={6}>
                            {localStorage.getItem("rondori_token") &&
                            item.is_remote ? (
                              <div>
                                <Button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    showModal(item.id);
                                  }}
                                  className="btn-gen-qr"
                                >
                                  สั่งงาน
                                </Button>
                              </div>
                            ) : null}
                          </Col>
                        </Row>
                      </div>
                    ))}
                </div>{" "}
              </>
            ) : (
              <div className="loading">
                <Preloader
                  use={ThreeDots}
                  size={60}
                  strokeWidth={6}
                  strokeColor="#c55a59"
                  duration={1500}
                />
              </div>
            )}
          </div>
        </div>
      )}

      <Modal
        className="modal-task"
        title={
          statusMachine &&
          statusMachine.machine_name &&
          statusMachine.machine_name.name_th
        }
        visible={isModalTask}
        footer={false}
        onCancel={handleCancel}
      >
        {isLoadData ? (
          <div className="loading">
            <Preloader
              use={ThreeDots}
              size={60}
              strokeWidth={6}
              strokeColor="#c55a59"
              duration={1500}
            />
          </div>
        ) : (
          <>
            <p className="txt-temp">
              {statusMachine && statusMachine.mode
                ? getTextMode(statusMachine.mode)
                : ""}
            </p>
            <p className="txt-opt">
              {statusMachine && statusMachine.option
                ? getTextOption(statusMachine.option)
                : ""}
            </p>
            <Divider />
            <p className={`txt-plus ${couponSelected ? "txt-dis" : ""}`}>
              ราคา{" "}
              {statusMachine && statusMachine.remain_balance
                ? numberWithCommas(statusMachine.remain_balance)
                : 0}{" "}
              บาท
            </p>
            <div style={{ marginTop: "15px" }}>
              <Select
                showSearch
                style={{ width: "100%" }}
                className="select-coupon"
                placeholder="ใช้คูปอง"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                filterSort={(optionA, optionB) =>
                  optionA.children
                    .toLowerCase()
                    .localeCompare(optionB.children.toLowerCase())
                }
                onChange={(e) => {
                  DropdownCoupon(e);
                }}
                value={couponSelected ? couponSelected : ""}
              >
                <Option value={""}>ไม่เลือกคูปอง</Option>
                {myCoupon &&
                  myCoupon.result.length > 0 &&
                  myCoupon.result.map((v, i) => (
                    <Option key={i} value={v.coupon_id}>
                      {v.name}
                    </Option>
                  ))}
              </Select>
              {couponSelected ? (
                <p className="txt-total-pay">รวม {total} บาท</p>
              ) : null}
            </div>

            <Divider />

            <div className="cov-action-task">
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  handleCancel();
                }}
                className="btn-cancel"
              >
                ยกเลิก
              </Button>
              <Button
                style={{ pointerEvents: isLoading ? "none" : null }}
                onClick={(e) => {
                  e.preventDefault();
                  setIsLoading(true);
                  remoteStart(statusMachine.machine_id);
                }}
                className="btn-confirm"
              >
                {isLoading ? <LoadingOutlined /> : "ยืนยัน"}
              </Button>
            </div>
          </>
        )}
      </Modal>

      <NavigationBar />
    </div>
  );
};

export default Home;
